var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "lbv-leak-list animated fadeIn roundedCard" },
    [
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-lg-12" },
          [
            _c(
              "b-card",
              [
                _c("div", { staticClass: "col-lg-12 leak-list-header" }, [
                  _c("span", { staticClass: "lbv-page-title" }, [
                    _vm._v("User List"),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row secondary lbv-search" }, [
                  _c(
                    "form",
                    {
                      staticClass: "lbv-search-filter leak-list-form",
                      on: {
                        submit: function ($event) {
                          $event.preventDefault()
                          return _vm.fetchUsers.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "leaklistFilters container" },
                        [
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                { attrs: { cols: "6" } },
                                [
                                  _c(
                                    "b-row",
                                    [
                                      _c("b-col", { attrs: { cols: "3" } }, [
                                        _c("label", [_vm._v("User Role")]),
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "b-col",
                                        { attrs: { cols: "9" } },
                                        [
                                          _c(
                                            "b-form-select",
                                            {
                                              staticClass: "full-width",
                                              attrs: { id: "statusFilter" },
                                              on: { input: _vm.fetchUsers },
                                              nativeOn: {
                                                change: function ($event) {
                                                  return _vm.onChange.apply(
                                                    null,
                                                    arguments
                                                  )
                                                },
                                              },
                                              model: {
                                                value: _vm.roleSelection,
                                                callback: function ($$v) {
                                                  _vm.roleSelection = $$v
                                                },
                                                expression: "roleSelection",
                                              },
                                            },
                                            _vm._l(
                                              _vm.userRoles,
                                              function (role) {
                                                return _c(
                                                  "option",
                                                  _vm._b(
                                                    {
                                                      key: role.id,
                                                      domProps: {
                                                        value: role.id,
                                                      },
                                                    },
                                                    "option",
                                                    _vm.$attrs,
                                                    false
                                                  ),
                                                  [
                                                    _vm._v(
                                                      "\n                          " +
                                                        _vm._s(role.name) +
                                                        "\n                        "
                                                    ),
                                                  ]
                                                )
                                              }
                                            ),
                                            0
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                { attrs: { cols: "6" } },
                                [
                                  _c(
                                    "b-button",
                                    {
                                      staticClass: "addUser",
                                      attrs: { variant: "primary" },
                                      on: { click: _vm.addUserClicked },
                                    },
                                    [
                                      _vm._v(
                                        "\n                    Add New User\n                  "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("b-table", {
                  attrs: {
                    striped: "",
                    hover: "",
                    items: _vm.userList,
                    fields: _vm.fields,
                    "per-page": _vm.perPage,
                    "current-page": _vm.currentPage,
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "username",
                      fn: function (data) {
                        return [
                          _c(
                            "b-link",
                            {
                              staticClass: "deviceLink",
                              on: {
                                click: function ($event) {
                                  return _vm.showUserDetails(data)
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(data.value) +
                                  "\n            "
                              ),
                            ]
                          ),
                        ]
                      },
                    },
                    {
                      key: "reset",
                      fn: function (data) {
                        return [
                          _c(
                            "b-link",
                            {
                              staticClass: "deviceLink",
                              on: {
                                click: function ($event) {
                                  return _vm.reset(data)
                                },
                              },
                            },
                            [_vm._v("\n              Reset 2FA\n            ")]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c(
                  "b-button",
                  {
                    staticClass: "page prev",
                    attrs: {
                      variant: "primary",
                      size: "sm",
                      disabled: _vm.pageNumber === 1,
                    },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.page.apply(null, arguments)
                      },
                    },
                  },
                  [_vm._v("\n          Prev\n        ")]
                ),
                _vm._v(" "),
                _c(
                  "b-button",
                  {
                    staticClass: "page next",
                    attrs: {
                      variant: "primary",
                      size: "sm",
                      disabled: !_vm.hasNextPage,
                    },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.page.apply(null, arguments)
                      },
                    },
                  },
                  [_vm._v("\n          Next\n        ")]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "current-page" }, [
                  _vm._v(
                    "\n          Page: " + _vm._s(_vm.pageNumber) + "\n        "
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "b-modal",
                  {
                    ref: "addNewUser",
                    attrs: {
                      id: "add-new",
                      title: "Create User",
                      "ok-variant": "primary",
                      "ok-title": "Add User",
                    },
                    on: { ok: _vm.saveNewUser },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "col-md-12" },
                      [
                        _c(
                          "b-form-group",
                          {
                            attrs: {
                              horizontal: "",
                              label: "*Email:",
                              "label-cols": 3,
                            },
                          },
                          [
                            _c("b-input", {
                              attrs: { type: "email" },
                              model: {
                                value: _vm.newUser.email,
                                callback: function ($$v) {
                                  _vm.$set(_vm.newUser, "email", $$v)
                                },
                                expression: "newUser.email",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-form-group",
                          {
                            attrs: {
                              horizontal: "",
                              label: "*Role:",
                              "label-cols": 3,
                            },
                          },
                          [
                            _c(
                              "b-form-select",
                              {
                                staticClass: "full-width",
                                attrs: { id: "statusFilter" },
                                model: {
                                  value: _vm.newUser.role,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.newUser, "role", $$v)
                                  },
                                  expression: "newUser.role",
                                },
                              },
                              [
                                _c(
                                  "option",
                                  {
                                    attrs: { disabled: "" },
                                    domProps: { value: null },
                                  },
                                  [
                                    _vm._v(
                                      "\n                  Please select...\n                "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _vm._l(_vm.userRoles, function (role) {
                                  return _c(
                                    "option",
                                    _vm._b(
                                      {
                                        key: role.id,
                                        domProps: { value: role.id },
                                      },
                                      "option",
                                      _vm.$attrs,
                                      false
                                    ),
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(role.name) +
                                          "\n                "
                                      ),
                                    ]
                                  )
                                }),
                              ],
                              2
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-form-group",
                          {
                            attrs: {
                              horizontal: "",
                              label: "*Tenant:",
                              "label-cols": 3,
                            },
                          },
                          [
                            _c("div", { attrs: { id: "tenantSelection" } }, [
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.selected,
                                      expression: "selected",
                                    },
                                  ],
                                  staticClass: "custom-select",
                                  attrs: { id: "selectTenant" },
                                  on: {
                                    change: [
                                      function ($event) {
                                        var $$selectedVal =
                                          Array.prototype.filter
                                            .call(
                                              $event.target.options,
                                              function (o) {
                                                return o.selected
                                              }
                                            )
                                            .map(function (o) {
                                              var val =
                                                "_value" in o
                                                  ? o._value
                                                  : o.value
                                              return val
                                            })
                                        _vm.selected = $event.target.multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      },
                                      _vm.tenantSelected,
                                    ],
                                    input: _vm.fetchTenantsInGroup,
                                  },
                                },
                                [
                                  _c(
                                    "option",
                                    { attrs: { disabled: "", value: "" } },
                                    [
                                      _vm._v(
                                        "\n                    Select tenant\n                  "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm._l(_vm.tenants, function (tenant) {
                                    return _c(
                                      "option",
                                      {
                                        domProps: {
                                          value: {
                                            id: tenant.id,
                                            name: tenant.name,
                                            tenantGroup: tenant.tenant_group_id,
                                            tenantGroupName:
                                              tenant.tenant_group_name,
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                    " +
                                            _vm._s(tenant.name) +
                                            "\n                  "
                                        ),
                                      ]
                                    )
                                  }),
                                ],
                                2
                              ),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _vm.tenantGroupName !== ""
                          ? _c(
                              "span",
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      horizontal: "",
                                      label: "Tenant Group:",
                                      "label-cols": 3,
                                    },
                                  },
                                  [
                                    _c(
                                      "b-form-checkbox",
                                      {
                                        attrs: {
                                          plain: true,
                                          value: "1",
                                          "unchecked-value": "0",
                                        },
                                        on: { input: _vm.fetchTenantsInGroup },
                                        model: {
                                          value: _vm.newUser.tenantGroup,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.newUser,
                                              "tenantGroup",
                                              $$v
                                            )
                                          },
                                          expression: "newUser.tenantGroup",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                  Grant user tenant- group wide access\n                "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("div", [
                                      _c("strong", [
                                        _vm._v(_vm._s(_vm.tenantGroupName)),
                                      ]),
                                    ]),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "b-form-group",
                          {
                            attrs: {
                              horizontal: "",
                              label: "*Language:",
                              "label-cols": 3,
                            },
                          },
                          [
                            _c("b-form-select", {
                              attrs: { options: _vm.languages },
                              model: {
                                value: _vm.newUser.language,
                                callback: function ($$v) {
                                  _vm.$set(_vm.newUser, "language", $$v)
                                },
                                expression: "newUser.language",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "b-modal",
                  {
                    ref: "userDetails",
                    attrs: {
                      id: "user-details",
                      title: "User Details",
                      "ok-variant": "primary",
                      "ok-title": "Save",
                    },
                    on: { ok: _vm.updateUser },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "col-md-12" },
                      [
                        _c(
                          "b-form-group",
                          {
                            attrs: {
                              horizontal: "",
                              label: "First Name:",
                              "label-cols": 3,
                            },
                          },
                          [
                            _c("b-input", {
                              attrs: { type: "text" },
                              model: {
                                value: _vm.selectedUser.first_name,
                                callback: function ($$v) {
                                  _vm.$set(_vm.selectedUser, "first_name", $$v)
                                },
                                expression: "selectedUser.first_name",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-form-group",
                          {
                            attrs: {
                              horizontal: "",
                              label: "Last Name:",
                              "label-cols": 3,
                            },
                          },
                          [
                            _c("b-input", {
                              attrs: { type: "text" },
                              model: {
                                value: _vm.selectedUser.last_name,
                                callback: function ($$v) {
                                  _vm.$set(_vm.selectedUser, "last_name", $$v)
                                },
                                expression: "selectedUser.last_name",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-form-group",
                          {
                            attrs: {
                              horizontal: "",
                              label: "Email:",
                              "label-cols": 3,
                            },
                          },
                          [
                            _c("b-input", {
                              attrs: { type: "email" },
                              model: {
                                value: _vm.selectedUser.username,
                                callback: function ($$v) {
                                  _vm.$set(_vm.selectedUser, "username", $$v)
                                },
                                expression: "selectedUser.username",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-form-group",
                          {
                            attrs: {
                              horizontal: "",
                              label: "Mobile Tel:",
                              "label-cols": 3,
                            },
                          },
                          [
                            _c("b-input", {
                              attrs: { type: "tel" },
                              model: {
                                value: _vm.selectedUser.mobile_number,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.selectedUser,
                                    "mobile_number",
                                    $$v
                                  )
                                },
                                expression: "selectedUser.mobile_number",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }